/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Role creation data
 * @export
 * @interface CreateRoleRequest
 */
export interface CreateRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleRequest
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleRequest
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleRequest
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the CreateRoleRequest interface.
 */
export function instanceOfCreateRoleRequest(value: object): value is CreateRoleRequest {
    return true;
}

export function CreateRoleRequestFromJSON(json: any): CreateRoleRequest {
    return CreateRoleRequestFromJSONTyped(json, false);
}

export function CreateRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'active': json['active'] == null ? undefined : json['active'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function CreateRoleRequestToJSON(json: any): CreateRoleRequest {
    return CreateRoleRequestToJSONTyped(json, false);
}

export function CreateRoleRequestToJSONTyped(value?: CreateRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'display_name': value['displayName'],
        'description': value['description'],
        'permissions': value['permissions'],
        'active': value['active'],
        'tenant_id': value['tenantId'],
    };
}

